/**
 * Contact (pick A "Answers, then write" on PLAN-page-contact.html, 2026-10-03, judged in dark). The
 * headline is the route's own line; faqEyebrow, faqSub and the form copy are v1's ContactGrid and
 * ContactForm, word for word.
 */
export const contactPage = {
  eyebrow: 'Contact',
  titleThin: 'Tell me where',
  titleBold: 'your leads stop.',
  lede: 'Read the answers first. If your question is still open, write and I will reply with a plan or a straight no.',
  faqEyebrow: 'FAQs',
  faqTitle: 'Quick answers',
  faqSub: 'Still have one? Write below.',
  cardTitle: 'Send me the bottleneck',
  cardBody: 'Where do leads stop? What are you running it on? Two or three lines is enough.',
}

/** The form. Until a backend is wired, Send opens the visitor's own mail app with the message laid out. */
export const contactForm = {
  first: 'First name',
  last: 'Last name',
  email: 'Email',
  message: 'Tell me more about your business',
  phFirst: 'Kenneth',
  phLast: 'Villar',
  phEmail: 'you@yourbusiness.com',
  phMessage: 'What is the bottleneck? Where do leads stop? What are you running it on?',
  send: 'Send message',
  hint: 'One business day. No newsletter, no drip.',
  error: 'Add your name, a real email, and a short note.',
  sentTitle: 'Your mail app has it.',
  sentBody: 'The message is laid out and addressed. Press send there and you will hear back within one business day.',
  // [CONFIRM] new lines (2026-10-03): the fallback for a visitor whose browser has no mail app set up.
  noMailApp: 'No mail app opened? Write to',
  copy: 'Copy message',
  copied: 'Copied',
  again: 'Write another',
}

export const notFoundPage = {
  eyebrow: '404',
  title: 'Page not found.',
  body: "That URL doesn't exist. If you followed a link that should work, email me and I'll look into it.",
}

export const cookieNotice = {
  title: 'Your browser, your call',
  body: 'Essential storage keeps your theme and sidebar choice on this device. Analytics stays off unless you allow it.',
  allow: 'Allow analytics',
  essential: 'Essential only',
  policy: 'Privacy policy',
}
